module.exports = __webpack_public_path__ + "static/media/bwdi.73a95b57.png";